/**
 * App 引导工具函数
 * 处理应用引导的状态管理
 */

/**
 * 检查是否已经完成应用引导
 */
export const hasCompletedAppOnboarding = (): boolean => {
  try {
    return localStorage.getItem('tempo-app-onboarding-completed') === 'true';
  } catch (e) {
    console.warn('[AppOnboardingUtils] Failed to check app onboarding status:', e);
    return false;
  }
};

/**
 * 标记应用引导已完成
 */
export const markAppOnboardingCompleted = (): void => {
  try {
    localStorage.setItem('tempo-app-onboarding-completed', 'true');
    localStorage.setItem('tempo-app-onboarding-completed-at', new Date().toISOString());
  } catch (e) {
    console.warn('[AppOnboardingUtils] Failed to mark app onboarding completed:', e);
  }
};

/**
 * 重置应用引导状态（用于重新体验）
 */
export const resetAppOnboardingStatus = (): void => {
  try {
    localStorage.removeItem('tempo-app-onboarding-completed');
    localStorage.removeItem('tempo-app-onboarding-completed-at');
  } catch (e) {
    console.warn('[AppOnboardingUtils] Failed to reset app onboarding status:', e);
  }
};

/**
 * 检查是否需要显示应用引导
 */
export const shouldShowAppOnboarding = (): boolean => {
  // 检查环境变量是否启用了应用引导功能
  const isOnboardingEnabled = import.meta.env.VITE_APP_ONBOARDING_ENABLED === 'true';

  if (!isOnboardingEnabled) {
    return false;
  }

  return !hasCompletedAppOnboarding();
};

/**
 * 获取应用引导完成时间
 */
export const getAppOnboardingCompletedAt = (): string | null => {
  try {
    return localStorage.getItem('tempo-app-onboarding-completed-at');
  } catch (e) {
    console.warn('[AppOnboardingUtils] Failed to get app onboarding completed time:', e);
    return null;
  }
};
